// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface IOrganizationPropertiesStateConfigResponseDto
 */
export interface IOrganizationPropertiesStateConfigResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertiesStateConfigResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationPropertiesStateConfigResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationPropertiesStateConfigResponseDto
     */
    description?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof IOrganizationPropertiesStateConfigResponseDto
     */
    roles_applied_to?: Set<string>;
    /**
     * 
     * @type {{ [key: string]: IFieldStateType; }}
     * @memberof IOrganizationPropertiesStateConfigResponseDto
     */
    properties?: { [key: string]: IFieldStateType; };
    /**
     * 
     * @type {{ [key: string]: IFieldStateType; }}
     * @memberof IOrganizationPropertiesStateConfigResponseDto
     */
    overridable_properties?: { [key: string]: IFieldStateType; };
}

/**
 * Check if a given object implements the IOrganizationPropertiesStateConfigResponseDto interface.
 */
export function instanceOfIOrganizationPropertiesStateConfigResponseDto(value: object): value is IOrganizationPropertiesStateConfigResponseDto {
    return true;
}

export function IOrganizationPropertiesStateConfigResponseDtoFromJSON(json: any): IOrganizationPropertiesStateConfigResponseDto {
    return IOrganizationPropertiesStateConfigResponseDtoFromJSONTyped(json, false);
}

export function IOrganizationPropertiesStateConfigResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationPropertiesStateConfigResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'roles_applied_to': json['roles_applied_to'] == null ? undefined : new Set(json['roles_applied_to']),
        'properties': json['properties'] == null ? undefined : (mapValues(json['properties'], IFieldStateTypeFromJSON)),
        'overridable_properties': json['overridable_properties'] == null ? undefined : (mapValues(json['overridable_properties'], IFieldStateTypeFromJSON)),
    };
}

export function IOrganizationPropertiesStateConfigResponseDtoToJSON(json: any): IOrganizationPropertiesStateConfigResponseDto {
    return IOrganizationPropertiesStateConfigResponseDtoToJSONTyped(json, false);
}

export function IOrganizationPropertiesStateConfigResponseDtoToJSONTyped(value?: IOrganizationPropertiesStateConfigResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'roles_applied_to': value['roles_applied_to'] == null ? undefined : Array.from(value['roles_applied_to'] as Set<any>),
        'properties': value['properties'] == null ? undefined : (mapValues(value['properties'], IFieldStateTypeToJSON)),
        'overridable_properties': value['overridable_properties'] == null ? undefined : (mapValues(value['overridable_properties'], IFieldStateTypeToJSON)),
    };
}

